import { useTranslation } from 'react-i18next';

import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';
import {
  LeftBorderCoverage,
  MaxSliderValueContainer,
  RightBorderCoverage,
  StackedElectedSlider,
  StackedMaxSlider,
  StackedVolumeSliderContainer,
} from './StackedVolumeStyled';
import { IncrementDto } from 'enrollment/queries/useBenefitPlansQuery/types';

export interface StackedVolumeSliderProps {
  totalElected: number;
  min: number;
  max: number;
  lastNonEoiIncrements: (IncrementDto | undefined)[];
}

export const StackedVolumeSlider = ({
  totalElected,
  min,
  max,
  lastNonEoiIncrements,
}: StackedVolumeSliderProps) => {
  const { t } = useTranslation('pages.stackedVolume');
  let minDisplay = min;
  lastNonEoiIncrements.forEach((increment) => {
    if (increment) {
      minDisplay += parseFloat(increment.volume);
    }
  });

  const width = (totalElected / max) * 100;
  const guaranteedWidth = (minDisplay / max) * 100;

  return (
    <StackedVolumeSliderContainer className="px-md-5">
      <p className="body1 semiBold">{t('sliderText')}</p>
      {width < 85 ? (
        <LeftBorderCoverage $margin={`${width}%`}>
          <p className="body2 mb-0">{t('electedCov')}</p>
          <p className="body1 semiBold">
            {getPremiumStyled({
              premium: String(totalElected || 0),
              valueOnly: RETURN_VALUE_ONLY,
            })}
          </p>
        </LeftBorderCoverage>
      ) : (
        <RightBorderCoverage $margin={`${100 - width}%`}>
          <p className="body2 mb-0">{t('electedCov')}</p>
          <p className="body1 semiBold">
            {getPremiumStyled({
              premium: String(totalElected || 0),
              valueOnly: RETURN_VALUE_ONLY,
            })}
          </p>
        </RightBorderCoverage>
      )}
      <StackedElectedSlider $width={`${width}%`} />
      <StackedMaxSlider />
      <MaxSliderValueContainer>
        {guaranteedWidth < 68 || minDisplay === min ? (
          <LeftBorderCoverage
            $margin={guaranteedWidth > 0 ? `${guaranteedWidth}%` : undefined}
          >
            <p className="body2 mb-0 pt-2">
              {minDisplay > min ? t('guaranteed') : t('min')}
            </p>
            <p className="body1 semiBold">
              {getPremiumStyled({
                premium: String(minDisplay || 0),
                valueOnly: RETURN_VALUE_ONLY,
              })}
            </p>
          </LeftBorderCoverage>
        ) : (
          <RightBorderCoverage $margin={`${guaranteedWidth - 100}%`}>
            <p className="body2 mb-0 pt-2">{t('guaranteed')}</p>
            <p className="body1 semiBold">
              {getPremiumStyled({
                premium: String(minDisplay || 0),
                valueOnly: RETURN_VALUE_ONLY,
              })}
            </p>
          </RightBorderCoverage>
        )}
        <RightBorderCoverage>
          <p className="body2 mb-0 pt-2">{t('max')}</p>
          <p className="body1 semiBold">
            {getPremiumStyled({
              premium: String(max || 0),
              valueOnly: RETURN_VALUE_ONLY,
            })}
          </p>
        </RightBorderCoverage>
      </MaxSliderValueContainer>
    </StackedVolumeSliderContainer>
  );
};
